import { useEffect, useState } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { Link } from "react-router-dom";
import DeleteConfig from "./DeleteConfig";

const Configs = () => {
    const { auth } = useAuth();
    const [configs, setConfigs] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [configID, setConfigID] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axiosPrivate.get("/flow-configs", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setConfigs(response.data);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate]);

    const DeleteCong = (evt) => {
        setConfigID(evt.target.id)
    }

    return (
        <div>
            {configID && <DeleteConfig configID={configID} setConfigID={setConfigID} setConfigs={setConfigs} />}
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Flow Config</span>
                </span>
            </div>
            <div>
                <Link to="/add-config">
                    <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                        Add Flow Config
                    </strong>
                </Link>

                <div className="overflow-x-auto" style={{paddingTop:'1.5rem'}}>
                    <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                        <thead className="ltr:text-left rtl:text-right">
                            <tr>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow ID</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow Name</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow Header</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow Body</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow CTA</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow Action</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow Mode</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Flow Footer</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                            {configs.map(config => (
                                <tr className="odd:bg-gray-50" key={config.id}>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_id}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_name}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_header}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_body}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_cta}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_action}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_mode}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{config.flow_footer}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700 flex gap-x-1.5">
                                        <Link to={`/edit-flow-configs/${config.id}`}>Edit</Link>
                                        <button onClick={DeleteCong} id={config.id} type="button">
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                </div>
        </div>
    )
}

export default Configs